import React, { useEffect, useState } from 'react';

/** Shared V2 → legacy URL fallback for background images. */
export function useImageWithFallback(src, fallbackSrc) {
    const [current, setCurrent] = useState(src);

    useEffect(() => {
        setCurrent(src);
    }, [src]);

    useEffect(() => {
        if (!src || !fallbackSrc || src === fallbackSrc) return undefined;

        let cancelled = false;
        const probe = new Image();
        probe.onload = () => {
            if (!cancelled) setCurrent(src);
        };
        probe.onerror = () => {
            if (!cancelled) setCurrent(fallbackSrc);
        };
        probe.src = src;

        return () => {
            cancelled = true;
        };
    }, [src, fallbackSrc]);

    return current;
}

/**
 * Background-image media block with V2 → legacy fallback (for course cards).
 */
const Dv2ElearningMedia = ({
    src,
    fallbackSrc,
    className,
    children,
    style,
    ...rest
}) => {
    const current = useImageWithFallback(src, fallbackSrc);

    if (!current) return null;

    return (
        <div
            className={className}
            style={{
                ...style,
                backgroundImage: `url("${current}")`,
            }}
            {...rest}
        >
            {children}
        </div>
    );
};

export default Dv2ElearningMedia;
